import { Link } from 'react-router-dom';
import { heroArticles, hotTags } from '@/mocks/home';

export default function HeroSection() {
  const mainArticle = heroArticles[0];
  const sideArticles = heroArticles.slice(1);

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center">
      <div className="absolute inset-0">
        <img
          src={mainArticle.imageUrl}
          alt="黑料在线头条爆料"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-12">
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-3/5 flex flex-col justify-end min-h-[420px] md:min-h-[500px]">
            <div className="mt-auto">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-semibold tracking-wide mb-4 whitespace-nowrap">
                {mainArticle.category}
              </span>
              <Link to={`/article/${mainArticle.id}`} className="block group cursor-pointer">
                <h2 className="text-3xl md:text-5xl font-heading font-black text-white leading-tight group-hover:text-accent-300 transition-colors">
                  {mainArticle.title}
                </h2>
              </Link>
              <p className="mt-4 text-sm md:text-base text-white/70 max-w-2xl leading-relaxed">
                {mainArticle.excerpt}
              </p>
              <div className="flex items-center gap-6 mt-5 text-xs text-white/50">
                <span>{mainArticle.date}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  {mainArticle.views}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  {mainArticle.comments}
                </span>
              </div>
            </div>
          </div>

          <div className="lg:w-2/5 flex flex-col gap-4 justify-end">
            {sideArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group flex gap-4 p-3 rounded-lg bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all cursor-pointer"
              >
                <div className="w-24 h-20 md:w-28 md:h-24 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-center">
                  <span className="text-xs text-accent-400 font-medium mb-1">{article.category}</span>
                  <h3 className="text-sm md:text-base font-semibold text-white line-clamp-2 group-hover:text-accent-300 transition-colors leading-snug">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-4 mt-1.5 text-xs text-white/40">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-0.5">
                      <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                      {article.views}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2 mt-8">
          <span className="text-xs text-white/50 mr-1 whitespace-nowrap">
            <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center inline"></i>
            {' '}热门标签：
          </span>
          {hotTags.map((tag) => (
            <Link
              key={tag.name}
              to={`/category/${tag.name}`}
              className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/10 hover:bg-white/25 text-white/80 hover:text-white text-xs transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              {tag.name}
              <span className="text-white/40">{tag.count}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}